<template>
     <v-container
        fluid
        tag="section"
    >
        <logged-in>
            <v-text-field 
                v-model="query"
                filled
                shaped      
                placeholder="Search"
            >
                <template #prepend-inner>
                    <v-icon>mdi-magnify</v-icon>
                </template>
            </v-text-field>   
            <div
                v-for="universe in shownUniverses"
                :key="`universe-${universe.id}`"
            >
                <universe-dashboard 
                    :universe="universe" 
                    :query="query"
                />
            </div>
            <template #fallback>                
                <div>
                    <div
                        v-for="universe in universes.items"
                        :key="`universe-${universe.id}`"
                    >
                        <universe-hub :universe="universe" />                
                    </div>
                </div>
            </template>
        </logged-in>
    </v-container>
</template>
<script>
    import { mapState, mapActions } from 'pinia'
    import { useUniverseStore } from '@/store/universe-store'
    import UniverseDashboard from './DashboardItem.vue'
    import UniverseHub from './HubItem.vue'

    export default {
        name: 'UniverseList',
        components: {
            UniverseDashboard,
            UniverseHub,
        },
        data: () => ({
            query: '',
        }),
        computed: {
            ...mapState(useUniverseStore, ['universes']),
            shownUniverses () {
                if (!this.$route.params.universe) {
                    return this.universes.items
                }
                return this.universes.items.filter(universe => universe.id === this.$route.params.universe)
            },
        },
        async mounted () {
            await this.loadUniverses()
        },        
        unmounted () {
            this.teal = false
        },
        beforeDestroy () {
            this.teal = false
        },
        deactivated () {
            this.teal = false
        },
        methods: {
            ...mapActions(useUniverseStore, ['loadUniverses']),
        },
    }

</script>
